import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { DropdownMenuItem, DropdownMenuDivider } from '@bibliocommons/base-dropdown';

import BatchActionsListItem from '../../../shared/BatchActions/BatchActionsListItem';
import BatchActionsListContainer from '../../../../containers/shared/BatchActions/BatchActionsListContainer';
import ItemList from '../../../shared/ItemList';
import CheckedOutItem from '../CheckedOutItem';
import renderAddToShelfBatchActions from '../../shared/AddToShelfBatchActions';
import BatchActionLink from '../../../shared/BatchActions/BatchActionLink';

export default class CheckedOutList extends BcReactComponent {

  constructor(props) {
    super(props);
    this.bindAll('renderBatchActionsMenu');
  }

  batchActionsLoading() {
    return this.props.items.some(item => this.anyActionInProgressForItem(item));
  }

  anyActionInProgressForItem(item) {
    const { checkoutTransactions, shelfTransactions } = this.props;
    const checkoutId = item.get('checkoutId');
    const metadataId = item.get('metadataId');

    const anyOngoingCheckoutAction = !checkoutTransactions.get(checkoutId, Immutable.Map()).isEmpty();
    const anyOngoingShelfAction = !shelfTransactions.get(metadataId, Immutable.Map()).isEmpty();

    return anyOngoingCheckoutAction || anyOngoingShelfAction;
  }

  renderBibListItem(item, selectedItems, updateItem) {
    const { accountId, checkoutActions, workflowActions, ratingsActions } = this.props;

    const actionItem = Immutable.Map({
      id: item.get('checkoutId'),
      metadataId: item.getIn(['bib', 'briefInfo', 'metadataId']),
      actions: item.get('actions', Immutable.List())
    });

    return (
      <BatchActionsListItem
        key={item.get('checkoutId')}
        actionItem={actionItem}
        selectedItems={selectedItems}
        updateItem={updateItem}>
        <CheckedOutItem
          actionInProgress={this.anyActionInProgressForItem(item)}
          accountId={accountId}
          item={item}
          checkoutTransactions={this.props.checkoutTransactions}
          shelfTransactions={this.props.shelfTransactions}
          ratingsTransactions={this.props.ratingsTransactions}
          checkoutActions={checkoutActions}
          workflowActions={workflowActions}
          rating={this.props.ratings.get(item.get('metadataId'))}
          ratingsActions={ratingsActions} />
      </BatchActionsListItem>
    );
  }

  renderRenewBatchAction(selectedActionItems) {
    const renewBatchActionItems = selectedActionItems.filter((item) => item.get('actions').includes('renew'));
    return (
      <DropdownMenuItem key="checked-out-batch-actions-renew">
        <BatchActionLink
          disabled={renewBatchActionItems.size === 0}
          href="#checked-out-batch-actions-renew"
          handleClick={() => this.props.handleBatchRenew(renewBatchActionItems)}>
          <FormattedMessage
            id="renew_items_with_count"
            values={{ count: renewBatchActionItems.size }} />
        </BatchActionLink>
      </DropdownMenuItem>
    );
  }

  renderBatchActionsMenu(selectedActionItems) {
    return [
      this.renderRenewBatchAction(selectedActionItems),
      <DropdownMenuDivider key="checked-out-batch-actions-divider" />,
      ...renderAddToShelfBatchActions({
        items: selectedActionItems,
        handleBatchAddToShelf: this.props.handleBatchAddToShelf
      })
    ];
  }

  render() {
    return (
      <div className="cp-checked-out-list">
        <BatchActionsListContainer
          actionIsLoading={this.batchActionsLoading()}
          list={this.props.actionList}
          totalItems={this.props.totalCount}
          renderActionsMenu={this.renderBatchActionsMenu}>
          {(selectedItems, updateItem) => (
            <ItemList>
              {this.props.items.map(item => this.renderBibListItem(item, selectedItems, updateItem))}
            </ItemList>
          )}
        </BatchActionsListContainer>
      </div>
    );
  }
}

CheckedOutList.propTypes = {
  accountId: PropTypes.number,
  items: ImmutablePropTypes.listOf(checkedOutItemShape),
  actionList: ImmutablePropTypes.list,
  shelfTransactions: ImmutablePropTypes.map,
  ratingsTransactions:  ImmutablePropTypes.map,
  totalCount: PropTypes.number,
  isFetching: PropTypes.bool,
  checkoutTransactions: ImmutablePropTypes.map,
  renderBatchActionButtons: PropTypes.func,
  checkoutActions: PropTypes.objectOf(PropTypes.func),
  workflowActions: PropTypes.objectOf(PropTypes.func),
  ratings: ImmutablePropTypes.map,
  ratingsActions: PropTypes.objectOf(PropTypes.func),
  handleBatchRenew: PropTypes.func,
  handleBatchAddToShelf: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutList/CheckedOutList.jsx